//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CurrencyButton',
  props: {
    store: { type: Object, required: true },
    code: { type: String, required: true },
    inline: { type: Boolean, default: false },
    discountCode: { type: String, default: null }
  },
  data: () => ({
    hovering: false
  }),
  computed: {
    selected () {
      return this.store.currency === this.storeCurrency
    }
  }
}
